module.exports = __webpack_public_path__ + "img/customized_m.a7fb58eb.jpg";